import { Table } from '@vwfs-bronson/bronson-react';
import { Team } from '../../fes';
import { formatInstallationId } from './teamForm';

export function TeamsTable({
  teams,
  selectedTeamId,
  onSelectTeam,
}: {
  teams: Team[];
  selectedTeamId?: string;
  onSelectTeam: (team: Team) => void;
}) {
  if (teams.length === 0) {
    return <p className="app-empty">No teams found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>Installation ID</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {teams.map(team => (
            <Table.Tr
              key={team.teamId || team.name}
              aria-selected={team.teamId === selectedTeamId}
              className="app-table-row--interactive"
              onClick={() => onSelectTeam(team)}
              onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onSelectTeam(team);
                }
              }}
              selected={team.teamId === selectedTeamId}
              tabIndex={0}
            >
              <Table.Td>{team.name}</Table.Td>
              <Table.Td>{team.description || '-'}</Table.Td>
              <Table.Td>{team.status}</Table.Td>
              <Table.Td>{formatInstallationId(team.installationId)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
